/// <amd-module name="VSS/Redux/Modules/Shortcuts/index" />
export * from "./ShortcutsActions";
export * from "./ShortcutsContracts";
export * from "./ShortcutsModule";
